import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Loader } from 'wix-style-react'
import { initWebSite } from 'controllers/webSite.js'
import styled from 'styled-components'

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

class WhimmWebSiteRunner extends Component {

  componentWillReceiveProps (nextProps) {
    const { authData, location, dispatch } = this.props
    if (authData.initializing && !_.has(nextProps.authData, 'auth.data.initializing')) {
      const strParams = location.search.substring(1)
      const params = {}
      _.map(_.split(strParams, '&'), str => {
        const pair = _.split(str, '=')
        params[pair[0]] = pair[1]
      })
      console.log('whimm-website constructor', params)
      dispatch(initWebSite(params))
    }
  }

  render () {
    return (
      <LoaderContainer>
        <Loader text='Loading...' />
      </LoaderContainer>
    )
  }
}

WhimmWebSiteRunner.propTypes = {
  location: PropTypes.object,
  authData: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  authData: state.authData
})

export default connect(mapStateToProps)(WhimmWebSiteRunner)



// WEBPACK FOOTER //
// ./src/components/pages/WhimmWebSiteRunner.js